import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import moment from 'moment';
import {
  Container,
  Grid,
  Paper,
  Typography,
  Box,
  Chip,
  IconButton,
  Tooltip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TableSortLabel,
  TextField,
  InputAdornment,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
  Badge,
  Card,
  CardContent,
  Divider,
  Tabs,
  Tab,
  FormControlLabel,
  Switch,
  Checkbox,
  Collapse,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  ImageList,
  ImageListItem,
  Snackbar
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert';
import RefreshIcon from '@material-ui/icons/Refresh';
import SearchIcon from '@material-ui/icons/Search';
import EmailIcon from '@material-ui/icons/Email';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import WarningIcon from '@material-ui/icons/Warning';
import SendIcon from '@material-ui/icons/Send';
import PhotoIcon from '@material-ui/icons/Photo';
import VisibilityIcon from '@material-ui/icons/Visibility';
import ReplayIcon from '@material-ui/icons/Replay';
import GetAppIcon from '@material-ui/icons/GetApp';
import UnsubscribeIcon from '@material-ui/icons/Unsubscribe';
import DateRangeIcon from '@material-ui/icons/DateRange';
import PeopleIcon from '@material-ui/icons/People';
import AssessmentIcon from '@material-ui/icons/Assessment';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ImageIcon from '@material-ui/icons/Image';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import LinearProgress from '@material-ui/core/LinearProgress';
import CloseIcon from '@material-ui/icons/Close';
import DoneIcon from '@material-ui/icons/Done';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
// Note: Using basic date input instead of DatePicker to avoid dependency issues

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(3),
    backgroundColor: '#f5f5f5',
    minHeight: '100vh'
  },
  header: {
    marginBottom: theme.spacing(3),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  title: {
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  statsCard: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },
  statValue: {
    fontSize: '2.5rem',
    fontWeight: 700,
    marginBottom: theme.spacing(1)
  },
  statLabel: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem'
  },
  filterSection: {
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    backgroundColor: '#fff',
    borderRadius: theme.spacing(1)
  },
  tableContainer: {
    marginTop: theme.spacing(2)
  },
  statusChip: {
    fontWeight: 600,
    fontSize: '0.75rem'
  },
  sentChip: {
    backgroundColor: '#2196f3',
    color: '#fff'
  },
  deliveredChip: {
    backgroundColor: '#4caf50',
    color: '#fff'
  },
  openedChip: {
    backgroundColor: '#00bcd4',
    color: '#fff'
  },
  bouncedChip: {
    backgroundColor: '#f44336',
    color: '#fff'
  },
  rejectedChip: {
    backgroundColor: '#ff5722',
    color: '#fff'
  },
  optedOutChip: {
    backgroundColor: '#9e9e9e',
    color: '#fff'
  },
  actionButtons: {
    display: 'flex',
    gap: theme.spacing(1)
  },
  photoPreview: {
    display: 'flex',
    gap: theme.spacing(1),
    flexWrap: 'wrap',
    '& img': {
      width: 40,
      height: 40,
      objectFit: 'cover',
      borderRadius: 4,
      cursor: 'pointer',
      '&:hover': {
        opacity: 0.8
      }
    }
  },
  dialogContent: {
    minWidth: 500
  },
  photoGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
    gap: theme.spacing(2),
    marginTop: theme.spacing(2)
  },
  exportButton: {
    marginLeft: theme.spacing(2)
  },
  tabs: {
    marginBottom: theme.spacing(3),
    borderBottom: `1px solid ${theme.palette.divider}`
  },
  coverageChip: {
    fontWeight: 600,
    fontSize: '0.75rem'
  },
  highCoverage: {
    backgroundColor: '#4caf50',
    color: '#fff'
  },
  mediumCoverage: {
    backgroundColor: '#ff9800',
    color: '#fff'
  },
  lowCoverage: {
    backgroundColor: '#f44336',
    color: '#fff'
  },
  eligibleCustomerCard: {
    marginBottom: theme.spacing(2),
    '&:hover': {
      boxShadow: theme.shadows[3]
    }
  },
  workorderSection: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: theme.palette.grey[50],
    borderRadius: theme.spacing(1)
  },
  workorderItem: {
    marginBottom: theme.spacing(1),
    backgroundColor: '#fff',
    '&:hover': {
      backgroundColor: theme.palette.grey[100]
    }
  },
  photoThumbnail: {
    width: 60,
    height: 60,
    objectFit: 'cover',
    borderRadius: 4,
    cursor: 'pointer',
    margin: theme.spacing(0.5),
    border: '2px solid transparent',
    '&:hover': {
      opacity: 0.8,
      border: '2px solid #2196f3'
    }
  },
  selectedPhoto: {
    border: '2px solid #2196f3'
  },
  photoPreviewDialog: {
    '& img': {
      width: '100%',
      height: 'auto',
      maxHeight: '70vh',
      objectFit: 'contain'
    }
  },
  workorderDetailDialog: {
    '& .MuiDialog-paper': {
      height: '90vh',
      maxHeight: '90vh'
    }
  },
  workorderDetailContent: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: 0
  },
  workorderDetailHeader: {
    padding: theme.spacing(3),
    borderBottom: `1px solid ${theme.palette.divider}`
  },
  photoGrid: {
    flex: 1,
    overflow: 'auto',
    padding: theme.spacing(3)
  },
  largePhotoThumbnail: {
    position: 'relative',
    cursor: 'pointer',
    borderRadius: 8,
    overflow: 'hidden',
    backgroundColor: theme.palette.grey[100],
    '&:hover': {
      '& $photoOverlay': {
        opacity: 1
      }
    }
  },
  photoOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: 0,
    transition: 'opacity 0.3s'
  },
  selectedPhotoOverlay: {
    opacity: 1,
    backgroundColor: 'rgba(33, 150, 243, 0.6)'
  },
  workorderDetailActions: {
    padding: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.divider}`
  },
  previewSection: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.grey[900],
    position: 'relative',
    overflow: 'hidden'
  },
  previewImage: {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain'
  },
  thumbnailSection: {
    height: 120,
    padding: theme.spacing(2),
    backgroundColor: theme.palette.grey[100],
    borderTop: `1px solid ${theme.palette.divider}`,
    overflowX: 'auto',
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center'
  },
  thumbnailItem: {
    position: 'relative',
    cursor: 'pointer',
    flexShrink: 0,
    borderRadius: 4,
    overflow: 'hidden',
    border: '3px solid transparent',
    transition: 'all 0.2s',
    '&:hover': {
      transform: 'scale(1.05)'
    }
  },
  thumbnailSelected: {
    border: '3px solid #2196f3'
  },
  thumbnailImage: {
    width: 80,
    height: 80,
    objectFit: 'cover'
  },
  photoSelectionCheckbox: {
    position: 'absolute',
    top: 4,
    right: 4,
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 1)'
    }
  },
  navigationButton: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    color: '#fff',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.7)'
    }
  },
  progressDialog: {
    '& .MuiDialog-paper': {
      minWidth: 500
    }
  },
  progressContent: {
    padding: theme.spacing(3)
  },
  progressHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(3)
  },
  progressSteps: {
    marginTop: theme.spacing(3)
  },
  progressStep: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1.5),
    marginBottom: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.grey[100],
    '&.active': {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.contrastText
    },
    '&.completed': {
      backgroundColor: theme.palette.success.light,
      color: theme.palette.success.contrastText
    },
    '&.error': {
      backgroundColor: theme.palette.error.light,
      color: theme.palette.error.contrastText
    }
  },
  progressIcon: {
    marginRight: theme.spacing(2)
  }
}));

const PhotoNotificationDashboard = ({ user }) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [notifications, setNotifications] = useState([]);
  const [eligibleCustomers, setEligibleCustomers] = useState([]);
  const [eligibleCustomersSummary, setEligibleCustomersSummary] = useState({});
  const [stats, setStats] = useState({
    total: 0,
    sent: 0,
    delivered: 0,
    opened: 0,
    bounced: 0,
    optedOut: 0
  });
  
  // New state for workorder management
  const [expandedCustomers, setExpandedCustomers] = useState({});
  const [photoPreviewDialog, setPhotoPreviewDialog] = useState({ open: false, photo: null });
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const [workorderDetailDialog, setWorkorderDetailDialog] = useState({ 
    open: false, 
    workorder: null, 
    customerId: null,
    photos: []
  });
  const [selectedPhotos, setSelectedPhotos] = useState({});
  const [currentPreviewIndex, setCurrentPreviewIndex] = useState(0);
  const [progressDialog, setProgressDialog] = useState({
    open: false,
    steps: [],
    currentStep: '',
    error: null,
    completed: false
  });
  
  // Table state
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [orderBy, setOrderBy] = useState('createdAt');
  const [order, setOrder] = useState('desc');
  
  // Filter state
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [includeOptedOut, setIncludeOptedOut] = useState(false);
  const [dateRange, setDateRange] = useState({
    start: moment().subtract(7, 'days').startOf('day').toDate(),
    end: moment().endOf('day').toDate()
  });
  
  // Dialog state
  const [detailsDialog, setDetailsDialog] = useState({ open: false, notification: null });
  const [retryDialog, setRetryDialog] = useState({ open: false, notification: null });

  // Use primitive timestamps so the effect only re-runs when dates actually change
  const dateRangeStartMs = dateRange.start?.getTime();
  const dateRangeEndMs = dateRange.end?.getTime();
  useEffect(() => {
    if (activeTab === 0) {
      fetchNotifications();
    } else {
      fetchEligibleCustomers();
    }
  }, [dateRangeStartMs, dateRangeEndMs, statusFilter, activeTab, includeOptedOut]);

  const fetchNotifications = async () => {
    setLoading(true);
    try {
      const response = await axios.get('/api/hmi/photo-notifications', {
        params: {
          startDate: dateRange.start,
          endDate: dateRange.end,
          status: statusFilter !== 'all' ? statusFilter : undefined
        }
      });
      
      setNotifications(response.data.notifications || []);
      setStats(response.data.stats || {
        total: 0,
        sent: 0,
        delivered: 0,
        opened: 0,
        bounced: 0,
        optedOut: 0
      });
    } catch (error) {
      console.error('Error fetching notifications:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchEligibleCustomers = async () => {
    setLoading(true);
    try {
      const response = await axios.get('/api/hmi/photo-notifications/eligible-customers', {
        params: {
          startDate: dateRange.start,
          endDate: dateRange.end,
          includeOptedOut: includeOptedOut,
          includeWorkorders: true // Request workorder details
        }
      });
      
      console.log('Eligible customers response:', response.data);
      setEligibleCustomers(response.data.customers || []);
      setEligibleCustomersSummary(response.data.summary || {});
    } catch (error) {
      console.error('Error fetching eligible customers:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleRetryNotification = async (notificationId) => {
    try {
      await axios.post(`/api/hmi/photo-notifications/${notificationId}/retry`);
      fetchNotifications();
      setRetryDialog({ open: false, notification: null });
    } catch (error) {
      console.error('Error retrying notification:', error);
    }
  };

  const handleExportData = async () => {
    try {
      const response = await axios.get('/api/hmi/photo-notifications/export', {
        params: {
          startDate: dateRange.start,
          endDate: dateRange.end,
          status: statusFilter !== 'all' ? statusFilter : undefined
        },
        responseType: 'blob'
      });
      
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `photo-notifications-${moment().format('YYYY-MM-DD')}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error('Error exporting data:', error);
    }
  };

  const filteredNotifications = notifications.filter(notification => {
    if (searchTerm) {
      const search = searchTerm.toLowerCase();
      return (
        notification.metadata.customerName?.toLowerCase().includes(search) ||
        notification.metadata.jobsiteName?.toLowerCase().includes(search) ||
        notification.recipientEmail?.toLowerCase().includes(search)
      );
    }
    return true;
  });

  const sortedNotifications = [...filteredNotifications].sort((a, b) => {
    let aValue = a[orderBy];
    let bValue = b[orderBy];
    
    if (orderBy.includes('.')) {
      const keys = orderBy.split('.');
      aValue = keys.reduce((obj, key) => obj?.[key], a);
      bValue = keys.reduce((obj, key) => obj?.[key], b);
    }
    
    if (order === 'asc') {
      return aValue > bValue ? 1 : -1;
    }
    return aValue < bValue ? 1 : -1;
  });

  const paginatedNotifications = sortedNotifications.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const getStatusColor = (status) => {
    const statusColors = {
      sent: classes.sentChip,
      delivered: classes.deliveredChip,
      opened: classes.openedChip,
      clicked: classes.openedChip,
      bounced: classes.bouncedChip,
      rejected: classes.rejectedChip,
      'soft-bounced': classes.bouncedChip,
      spam: classes.optedOutChip,
      unsub: classes.optedOutChip
    };
    return statusColors[status] || '';
  };

  const getCoverageColor = (coverage) => {
    if (coverage >= 80) return classes.highCoverage;
    if (coverage >= 50) return classes.mediumCoverage;
    return classes.lowCoverage;
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    setPage(0); // Reset pagination when switching tabs
  };

  // New handlers for workorder management
  const toggleCustomerExpansion = (customerId) => {
    setExpandedCustomers(prev => ({
      ...prev,
      [customerId]: !prev[customerId]
    }));
  };


  const handleOpenWorkorderDetail = (workorder, customerId, photos) => {
    setWorkorderDetailDialog({
      open: true,
      workorder,
      customerId,
      photos
    });
    setCurrentPreviewIndex(0);
    // Initialize selected photos for this workorder
    const photoKey = `${customerId}_${workorder._id}`;
    if (!selectedPhotos[photoKey]) {
      setSelectedPhotos(prev => ({
        ...prev,
        [photoKey]: {}
      }));
    }
  };

  const handlePhotoSelect = (photoId) => {
    const { customerId, workorder } = workorderDetailDialog;
    const photoKey = `${customerId}_${workorder._id}`;
    
    setSelectedPhotos(prev => ({
      ...prev,
      [photoKey]: {
        ...prev[photoKey],
        [photoId]: !prev[photoKey]?.[photoId]
      }
    }));
  };

  const handleSelectAllPhotos = () => {
    const { customerId, workorder, photos } = workorderDetailDialog;
    const photoKey = `${customerId}_${workorder._id}`;
    const allSelected = photos.every(photo => selectedPhotos[photoKey]?.[photo._id || photo.url]);
    
    setSelectedPhotos(prev => ({
      ...prev,
      [photoKey]: photos.reduce((acc, photo) => ({
        ...acc,
        [photo._id || photo.url]: !allSelected
      }), {})
    }));
  };

  const getSelectedPhotoCount = () => {
    const { customerId, workorder } = workorderDetailDialog;
    if (!customerId || !workorder) return 0;
    const photoKey = `${customerId}_${workorder._id}`;
    return Object.values(selectedPhotos[photoKey] || {}).filter(Boolean).length;
  };

  const handleSendFromModal = async () => {
    const { workorder, customerId, photos } = workorderDetailDialog;
    const photoKey = `${customerId}_${workorder._id}`;
    
    // Get only selected photos
    const selectedPhotoIds = photos
      .filter(photo => selectedPhotos[photoKey]?.[photo._id || photo.url])
      .map(photo => photo._id || photo.url);
    
    if (selectedPhotoIds.length === 0) {
      setSnackbar({
        open: true,
        message: 'Please select at least one photo',
        severity: 'warning'
      });
      return;
    }
    
    // Initialize progress dialog
    setProgressDialog({
      open: true,
      steps: [],
      currentStep: 'Initializing...',
      error: null,
      completed: false
    });
    
    // Close the workorder detail modal
    setWorkorderDetailDialog({ open: false, workorder: null, customerId: null, photos: [] });
    
    try {
      // Start the notification send process
      const response = await axios.post('/api/hmi/photo-notifications/send-manual', {
        customerId,
        workorderData: [{
          workorderId: workorder._id,
          photoIds: selectedPhotoIds
        }],
        streamProgress: true // Tell backend we want SSE progress
      });
      
      const { taskId } = response.data;
      
      // Set up SSE connection for progress updates
      const eventSource = new EventSource(`/api/hmi/photo-notifications/progress/${taskId}`);
      
      eventSource.onmessage = (event) => {
        const data = JSON.parse(event.data);
        
        setProgressDialog(prev => ({
          ...prev,
          steps: [...prev.steps, {
            message: data.message,
            status: data.status,
            timestamp: new Date()
          }],
          currentStep: data.message
        }));
        
        if (data.status === 'completed') {
          eventSource.close();
          setProgressDialog(prev => ({
            ...prev,
            completed: true,
            currentStep: 'Notification sent successfully!'
          }));
          
          // Clear photo selections
          setSelectedPhotos(prev => ({
            ...prev,
            [photoKey]: {}
          }));
          
          // Refresh the data
          fetchEligibleCustomers();
          
          // Auto-close after 3 seconds
          setTimeout(() => {
            setProgressDialog({
              open: false,
              steps: [],
              currentStep: '',
              error: null,
              completed: false
            });
          }, 3000);
        }
      };
      
      eventSource.onerror = (error) => {
        console.error('SSE Error:', error);
        eventSource.close();
        
        setProgressDialog(prev => ({
          ...prev,
          error: 'Connection lost. The notification may still be processing.',
          currentStep: 'Error occurred'
        }));
      };
      
    } catch (error) {
      setProgressDialog(prev => ({
        ...prev,
        error: error.response?.data?.message || error.message,
        currentStep: 'Failed to send notification'
      }));
    }
  };

  return (
    <Container className={classes.root} maxWidth={false}>
      <Box className={classes.header}>
        <Typography variant="h4" className={classes.title}>
          <PhotoIcon /> Photo Notification Dashboard
        </Typography>
        <Box>
          <Tooltip title="Refresh">
            <IconButton 
              onClick={() => activeTab === 0 ? fetchNotifications() : fetchEligibleCustomers()} 
              color="primary"
            >
              <RefreshIcon />
            </IconButton>
          </Tooltip>
          <Button
            variant="outlined"
            startIcon={<GetAppIcon />}
            onClick={handleExportData}
            className={classes.exportButton}
          >
            Export Data
          </Button>
        </Box>
      </Box>

      {/* Tabs */}
      <Tabs 
        value={activeTab} 
        onChange={handleTabChange} 
        className={classes.tabs}
        indicatorColor="primary"
        textColor="primary"
      >
        <Tab 
          label="Notification History" 
          icon={<EmailIcon />} 
          iconPosition="start"
        />
        <Tab 
          label="Eligible Customers" 
          icon={<PeopleIcon />} 
          iconPosition="start"
        />
      </Tabs>

      {/* Tab Content */}
      {activeTab === 0 ? (
        <>
          {/* Notification History Tab */}
          {/* Stats Cards */}
          <Grid container spacing={3} style={{ marginBottom: 24 }}>
            <Grid item xs={12} sm={6} md={2}>
              <Card className={classes.statsCard}>
                <CardContent>
                  <Typography className={classes.statValue} style={{ color: '#2196f3' }}>
                    {stats.total}
                  </Typography>
                  <Typography className={classes.statLabel}>Total Sent</Typography>
                </CardContent>
              </Card>
            </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <Card className={classes.statsCard}>
            <CardContent>
              <Typography className={classes.statValue} style={{ color: '#4caf50' }}>
                {stats.delivered}
              </Typography>
              <Typography className={classes.statLabel}>Delivered</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <Card className={classes.statsCard}>
            <CardContent>
              <Typography className={classes.statValue} style={{ color: '#00bcd4' }}>
                {stats.opened}
              </Typography>
              <Typography className={classes.statLabel}>Opened</Typography>
              <Typography variant="caption" color="textSecondary">
                {stats.delivered > 0 ? 
                  `${Math.round((stats.opened / stats.delivered) * 100)}% rate` : 
                  '0% rate'
                }
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <Card className={classes.statsCard}>
            <CardContent>
              <Typography className={classes.statValue} style={{ color: '#f44336' }}>
                {stats.bounced}
              </Typography>
              <Typography className={classes.statLabel}>Bounced</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <Card className={classes.statsCard}>
            <CardContent>
              <Typography className={classes.statValue} style={{ color: '#9e9e9e' }}>
                {stats.optedOut}
              </Typography>
              <Typography className={classes.statLabel}>Opted Out</Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Filters */}
      <Paper className={classes.filterSection}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Search by customer, jobsite, or email..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                )
              }}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <FormControl fullWidth variant="outlined">
              <InputLabel>Status Filter</InputLabel>
              <Select
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
                label="Status Filter"
              >
                <MenuItem value="all">All Statuses</MenuItem>
                <MenuItem value="sent">Sent</MenuItem>
                <MenuItem value="delivered">Delivered</MenuItem>
                <MenuItem value="opened">Opened</MenuItem>
                <MenuItem value="bounced">Bounced</MenuItem>
                <MenuItem value="rejected">Rejected</MenuItem>
                <MenuItem value="optedOut">Opted Out</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              variant="outlined"
              label="Start Date"
              type="date"
              value={moment(dateRange.start).format('YYYY-MM-DD')}
              onChange={(e) => setDateRange({ ...dateRange, start: new Date(e.target.value) })}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              variant="outlined"
              label="End Date"
              type="date"
              value={moment(dateRange.end).format('YYYY-MM-DD')}
              onChange={(e) => setDateRange({ ...dateRange, end: new Date(e.target.value) })}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>
      </Paper>

      {/* Table */}
      <TableContainer component={Paper} className={classes.tableContainer}>
        {loading ? (
          <Box display="flex" justifyContent="center" p={4}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <TableSortLabel
                      active={orderBy === 'createdAt'}
                      direction={orderBy === 'createdAt' ? order : 'asc'}
                      onClick={() => handleSort('createdAt')}
                    >
                      Sent Date
                    </TableSortLabel>
                  </TableCell>
                  <TableCell>Customer</TableCell>
                  <TableCell>Jobsite</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell align="center">Photos</TableCell>
                  <TableCell>
                    <TableSortLabel
                      active={orderBy === 'emailStatus.status'}
                      direction={orderBy === 'emailStatus.status' ? order : 'asc'}
                      onClick={() => handleSort('emailStatus.status')}
                    >
                      Status
                    </TableSortLabel>
                  </TableCell>
                  <TableCell align="center">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {paginatedNotifications.map((notification) => (
                  <TableRow key={notification._id}>
                    <TableCell>
                      {moment(notification.createdAt).format('MM/DD/YY h:mm A')}
                    </TableCell>
                    <TableCell>{notification.metadata.customerName}</TableCell>
                    <TableCell>{notification.metadata.jobsiteName}</TableCell>
                    <TableCell>
                      {notification.recipientEmail}
                      {notification.customerOptedOut && (
                        <Tooltip title="Customer has opted out">
                          <UnsubscribeIcon 
                            style={{ 
                              fontSize: 16, 
                              marginLeft: 4, 
                              verticalAlign: 'middle',
                              color: '#f44336' 
                            }} 
                          />
                        </Tooltip>
                      )}
                    </TableCell>
                    <TableCell align="center">
                      <Badge badgeContent={notification.photoCount} color="primary">
                        <PhotoIcon />
                      </Badge>
                    </TableCell>
                    <TableCell>
                      <Chip
                        label={notification.emailStatus.status}
                        size="small"
                        className={`${classes.statusChip} ${getStatusColor(notification.emailStatus.status)}`}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <Box className={classes.actionButtons}>
                        <Tooltip title="View Details">
                          <IconButton
                            size="small"
                            onClick={() => setDetailsDialog({ open: true, notification })}
                          >
                            <VisibilityIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        {notification.canRetry && (
                          <Tooltip title="Retry Send">
                            <IconButton
                              size="small"
                              onClick={() => setRetryDialog({ open: true, notification })}
                            >
                              <ReplayIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        )}
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[10, 25, 50, 100]}
              component="div"
              count={filteredNotifications.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onChangePage={(e, newPage) => setPage(newPage)}
              onChangeRowsPerPage={(e) => {
                setRowsPerPage(parseInt(e.target.value, 10));
                setPage(0);
              }}
            />
          </>
        )}
      </TableContainer>

      {/* Details Dialog */}
      <Dialog
        open={detailsDialog.open}
        onClose={() => setDetailsDialog({ open: false, notification: null })}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Notification Details</DialogTitle>
        <DialogContent className={classes.dialogContent}>
          {detailsDialog.notification && (
            <Box>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Typography variant="subtitle2" color="textSecondary">Customer</Typography>
                  <Typography>{detailsDialog.notification.metadata.customerName}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle2" color="textSecondary">Jobsite</Typography>
                  <Typography>{detailsDialog.notification.metadata.jobsiteName}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle2" color="textSecondary">Email</Typography>
                  <Typography>{detailsDialog.notification.recipientEmail}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle2" color="textSecondary">Status</Typography>
                  <Chip
                    label={detailsDialog.notification.emailStatus.status}
                    size="small"
                    className={`${classes.statusChip} ${getStatusColor(detailsDialog.notification.emailStatus.status)}`}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="subtitle2" color="textSecondary">Work Order</Typography>
                  <Typography>{detailsDialog.notification.metadata.workorderNumber}</Typography>
                </Grid>
                {detailsDialog.notification.emailStatus.sentAt && (
                  <Grid item xs={6}>
                    <Typography variant="subtitle2" color="textSecondary">Sent At</Typography>
                    <Typography>
                      {moment(detailsDialog.notification.emailStatus.sentAt).format('MM/DD/YY h:mm A')}
                    </Typography>
                  </Grid>
                )}
                {detailsDialog.notification.emailStatus.firstOpenedAt && (
                  <Grid item xs={6}>
                    <Typography variant="subtitle2" color="textSecondary">First Opened</Typography>
                    <Typography>
                      {moment(detailsDialog.notification.emailStatus.firstOpenedAt).format('MM/DD/YY h:mm A')}
                    </Typography>
                  </Grid>
                )}
                {detailsDialog.notification.failureReason && (
                  <Grid item xs={12}>
                    <Typography variant="subtitle2" color="textSecondary">Failure Reason</Typography>
                    <Typography color="error">{detailsDialog.notification.failureReason}</Typography>
                  </Grid>
                )}
              </Grid>
              
              <Divider style={{ margin: '16px 0' }} />
              
              <Typography variant="subtitle2" color="textSecondary" gutterBottom>
                Photos ({detailsDialog.notification.photoCount})
              </Typography>
              <Box className={classes.photoGrid}>
                {detailsDialog.notification.photoUrls.map((url, index) => (
                  <a key={index} href={url} target="_blank" rel="noopener noreferrer">
                    <img 
                      src={url} 
                      alt={`Photo ${index + 1}`} 
                      style={{ 
                        width: '100%', 
                        height: 150, 
                        objectFit: 'cover',
                        borderRadius: 4 
                      }} 
                    />
                  </a>
                ))}
              </Box>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDetailsDialog({ open: false, notification: null })}>
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Retry Dialog */}
      <Dialog
        open={retryDialog.open}
        onClose={() => setRetryDialog({ open: false, notification: null })}
      >
        <DialogTitle>Retry Notification</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to retry sending this notification to{' '}
            <strong>{retryDialog.notification?.recipientEmail}</strong>?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setRetryDialog({ open: false, notification: null })}>
            Cancel
          </Button>
          <Button
            onClick={() => handleRetryNotification(retryDialog.notification._id)}
            color="primary"
            variant="contained"
          >
            Retry Send
          </Button>
        </DialogActions>
      </Dialog>
        </>
      ) : (
        <>
          {/* Eligible Customers Tab */}
          <Grid container spacing={3} style={{ marginBottom: 24 }}>
            <Grid item xs={12} sm={6} md={3}>
              <Card className={classes.statsCard}>
                <CardContent>
                  <Typography className={classes.statValue} style={{ color: '#2196f3' }}>
                    {eligibleCustomersSummary.totalEligibleCustomers || 0}
                  </Typography>
                  <Typography className={classes.statLabel}>Eligible Customers</Typography>
                  <Typography variant="caption" color="textSecondary">
                    {eligibleCustomersSummary.totalContacts || 0} total contacts
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Card className={classes.statsCard}>
                <CardContent>
                  <Typography className={classes.statValue} style={{ color: '#4caf50' }}>
                    {eligibleCustomersSummary.activeEligible || 0}
                  </Typography>
                  <Typography className={classes.statLabel}>Active Recipients</Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Card className={classes.statsCard}>
                <CardContent>
                  <Typography className={classes.statValue} style={{ color: '#ff5722' }}>
                    {eligibleCustomersSummary.customersWithNoNotifications || 0}
                  </Typography>
                  <Typography className={classes.statLabel}>Never Received</Typography>
                  <Typography variant="caption" color="textSecondary">
                    Eligible but no emails sent
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Card className={classes.statsCard}>
                <CardContent>
                  <Typography className={classes.statValue} style={{ color: '#ff9800' }}>
                    {eligibleCustomersSummary.customersWithMissedOpportunities || 0}
                  </Typography>
                  <Typography className={classes.statLabel}>Missed Photos</Typography>
                  <Typography variant="caption" color="textSecondary">
                    Have workorders without notifications
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          {/* Filters for Eligible Customers */}
          <Paper className={classes.filterSection}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  variant="outlined"
                  placeholder="Search by customer name or email..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    )
                  }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={includeOptedOut}
                      onChange={(e) => setIncludeOptedOut(e.target.checked)}
                      color="primary"
                    />
                  }
                  label="Include Opted Out"
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Start Date"
                  type="date"
                  value={moment(dateRange.start).format('YYYY-MM-DD')}
                  onChange={(e) => setDateRange({ ...dateRange, start: new Date(e.target.value) })}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="End Date"
                  type="date"
                  value={moment(dateRange.end).format('YYYY-MM-DD')}
                  onChange={(e) => setDateRange({ ...dateRange, end: new Date(e.target.value) })}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          </Paper>

          {/* Eligible Customers List */}
          <Grid container spacing={2}>
            {loading ? (
              <Box display="flex" justifyContent="center" width="100%" p={4}>
                <CircularProgress />
              </Box>
            ) : (
              eligibleCustomers
                .filter(customer => {
                  if (!searchTerm) return true;
                  const search = searchTerm.toLowerCase();
                  return (
                    customer.name?.toLowerCase().includes(search) ||
                    customer.email?.toLowerCase().includes(search)
                  );
                })
                .map((customer) => (
                  <Grid item xs={12} md={6} key={customer._id}>
                    <Card className={classes.eligibleCustomerCard}>
                      <CardContent>
                        <Box display="flex" justifyContent="space-between" alignItems="flex-start">
                          <Box flex={1}>
                            <Typography variant="h6">{customer.name}</Typography>
                            <Typography variant="body2" color="textSecondary" gutterBottom>
                              {customer.contactCount} contact{customer.contactCount !== 1 ? 's' : ''} • 
                              {customer.agreementCount} agreement{customer.agreementCount !== 1 ? 's' : ''}
                            </Typography>
                            {customer.contacts && customer.contacts.length > 0 && (
                              <Typography variant="caption" color="textSecondary">
                                {customer.contacts.slice(0, 2).map(c => c.email).join(', ')}
                                {customer.contacts.length > 2 && ` +${customer.contacts.length - 2} more`}
                              </Typography>
                            )}
                          </Box>
                          <Box textAlign="right">
                            {customer.optedOut ? (
                              <Chip
                                label="Opted Out"
                                size="small"
                                className={`${classes.statusChip} ${classes.optedOutChip}`}
                                icon={<UnsubscribeIcon />}
                              />
                            ) : (
                              <Box>
                                <Chip
                                  label={`${customer.stats.coverage}% Coverage`}
                                  size="small"
                                  className={`${classes.coverageChip} ${getCoverageColor(customer.stats.coverage)}`}
                                />
                                {(customer.workorders && customer.workorders.length > 0 && customer.photos && customer.photos.length > 0) ? (
                                  <IconButton
                                    size="small"
                                    onClick={() => toggleCustomerExpansion(customer._id)}
                                    style={{ marginLeft: 8 }}
                                    title={`${customer.workorders.length || 0} workorders with ${customer.photos.length || 0} photos`}
                                  >
                                    {expandedCustomers[customer._id] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                  </IconButton>
                                ) : null}
                              </Box>
                            )}
                          </Box>
                        </Box>
                        
                        <Divider style={{ margin: '12px 0' }} />
                        
                        <Grid container spacing={2}>
                          <Grid item xs={6}>
                            <Typography variant="caption" color="textSecondary">
                              Notifications Sent
                            </Typography>
                            <Typography variant="body1">
                              {customer.stats.totalSent}
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography variant="caption" color="textSecondary">
                              Workorders with Photos
                            </Typography>
                            <Typography variant="body1">
                              {customer.stats.workordersWithPhotos}
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography variant="caption" color="textSecondary">
                              Delivered
                            </Typography>
                            <Typography variant="body1">
                              {customer.stats.delivered}
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography variant="caption" color="textSecondary">
                              Last Sent
                            </Typography>
                            <Typography variant="body1">
                              {customer.stats.lastSentAt ? 
                                moment(customer.stats.lastSentAt).format('MM/DD/YY') : 
                                'Never'
                              }
                            </Typography>
                          </Grid>
                        </Grid>
                        
                        {customer.stats.workordersWithPhotos > customer.stats.totalSent && !customer.optedOut && (
                          <Box mt={2} p={1} bgcolor="#fff3e0" borderRadius={4}>
                            <Typography variant="caption" style={{ color: '#e65100' }}>
                              <WarningIcon style={{ fontSize: 16, verticalAlign: 'middle', marginRight: 4 }} />
                              {customer.stats.workordersWithPhotos - customer.stats.totalSent} workorders 
                              with photos but no notification sent
                            </Typography>
                          </Box>
                        )}
                        
                        {customer.optedOut && (
                          <Box mt={2}>
                            <Typography variant="caption" color="textSecondary">
                              Opted out on {moment(customer.optOutDate).format('MM/DD/YY')} 
                              via {customer.optOutMethod}
                            </Typography>
                          </Box>
                        )}
                        
                        {/* Expandable Workorder Section */}
                        {!customer.optedOut && customer.workorders && customer.workorders.length > 0 && customer.photos && customer.photos.length > 0 && (
                          <Collapse in={expandedCustomers[customer._id]} timeout="auto" unmountOnExit>
                            <Box className={classes.workorderSection}>
                              {(() => {
                                // Group photos by workorder
                                const photosByWorkorder = {};
                                customer.photos.forEach(photo => {
                                  if (!photosByWorkorder[photo.workorder]) {
                                    photosByWorkorder[photo.workorder] = [];
                                  }
                                  photosByWorkorder[photo.workorder].push(photo);
                                });
                                
                                // Filter workorders that have photos
                                const workordersWithPhotos = customer.workorders.filter(wo => 
                                  photosByWorkorder[wo._id] && photosByWorkorder[wo._id].length > 0
                                );
                                
                                return workordersWithPhotos.length > 0 ? (
                                <>
                                  <Box mb={2}>
                                    <Typography variant="subtitle2">
                                      Workorders with Photos ({workordersWithPhotos.length})
                                    </Typography>
                                  </Box>
                                  
                                  <List dense>
                                    {workordersWithPhotos.map((workorder) => (
                                  <Paper key={workorder._id} className={classes.workorderItem}>
                                    <ListItem>
                                      <ListItemText
                                        primary={
                                          <Box>
                                            <Typography variant="body2">
                                              WO #{workorder.number} - {workorder.jobName || workorder.jobSiteAddress}
                                            </Typography>
                                            <Typography variant="caption" color="textSecondary">
                                              {moment(workorder.completedDate || workorder.completed_at).format('MM/DD/YY')} • 
                                              {photosByWorkorder[workorder._id].length} photo{photosByWorkorder[workorder._id].length !== 1 ? 's' : ''}
                                              {workorder.notificationSent && (
                                                <Chip
                                                  size="small"
                                                  label="Sent"
                                                  style={{ marginLeft: 8, height: 16 }}
                                                  className={classes.sentChip}
                                                />
                                              )}
                                            </Typography>
                                          </Box>
                                        }
                                        secondary={
                                          <Box display="flex" flexWrap="wrap" mt={1}>
                                            {photosByWorkorder[workorder._id].slice(0, 4).map((photo, index) => (
                                              <img
                                                key={index}
                                                src={photo.url}
                                                alt={`Photo ${index + 1}`}
                                                className={classes.photoThumbnail}
                                                onClick={() => setPhotoPreviewDialog({ open: true, photo: photo.url })}
                                              />
                                            ))}
                                            {photosByWorkorder[workorder._id].length > 4 && (
                                              <Box
                                                className={classes.photoThumbnail}
                                                display="flex"
                                                alignItems="center"
                                                justifyContent="center"
                                                bgcolor="#f5f5f5"
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => setPhotoPreviewDialog({ 
                                                  open: true, 
                                                  photo: photosByWorkorder[workorder._id][4].url 
                                                })}
                                              >
                                                <Typography variant="caption">
                                                  +{photosByWorkorder[workorder._id].length - 4}
                                                </Typography>
                                              </Box>
                                            )}
                                          </Box>
                                        }
                                      />
                                      <ListItemSecondaryAction>
                                        <Box display="flex" alignItems="center">
                                          {workorder.notificationSent && (
                                            <Tooltip title="Notification already sent">
                                              <CheckCircleIcon style={{ color: '#4caf50', marginRight: 8 }} />
                                            </Tooltip>
                                          )}
                                          <Tooltip title="Review and send photos">
                                            <IconButton
                                              edge="end"
                                              onClick={() => handleOpenWorkorderDetail(
                                                workorder, 
                                                customer._id, 
                                                photosByWorkorder[workorder._id]
                                              )}
                                            >
                                              <FullscreenIcon />
                                            </IconButton>
                                          </Tooltip>
                                        </Box>
                                      </ListItemSecondaryAction>
                                    </ListItem>
                                  </Paper>
                                    ))}
                                  </List>
                                </>
                              ) : (
                                <Box p={2} textAlign="center">
                                  <Typography variant="body2" color="textSecondary">
                                    No workorders with photos found
                                  </Typography>
                                </Box>
                              );
                              })()}
                            </Box>
                          </Collapse>
                        )}
                      </CardContent>
                    </Card>
                  </Grid>
                ))
            )}
          </Grid>
        </>
      )}

      {/* Photo Preview Dialog */}
      <Dialog
        open={photoPreviewDialog.open}
        onClose={() => setPhotoPreviewDialog({ open: false, photo: null })}
        maxWidth="md"
        fullWidth
        className={classes.photoPreviewDialog}
      >
        <DialogContent>
          {photoPreviewDialog.photo && (
            <img src={photoPreviewDialog.photo} alt="Preview" />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setPhotoPreviewDialog({ open: false, photo: null })}>
            Close
          </Button>
        </DialogActions>
      </Dialog>


      {/* Workorder Detail Dialog */}
      <Dialog
        open={workorderDetailDialog.open}
        onClose={() => setWorkorderDetailDialog({ open: false, workorder: null, customerId: null, photos: [] })}
        maxWidth="lg"
        fullWidth
        className={classes.workorderDetailDialog}
      >
        {workorderDetailDialog.workorder && (
          <Box className={classes.workorderDetailContent}>
            <Box className={classes.workorderDetailHeader}>
              <Grid container alignItems="center" spacing={2}>
                <Grid item xs>
                  <Typography variant="h5" gutterBottom>
                    Work Order #{workorderDetailDialog.workorder.number}
                  </Typography>
                  <Typography variant="body1" color="textSecondary">
                    {workorderDetailDialog.workorder.jobName || workorderDetailDialog.workorder.jobSiteAddress}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Completed: {moment(workorderDetailDialog.workorder.completedDate || workorderDetailDialog.workorder.completed_at).format('MMMM DD, YYYY')}
                  </Typography>
                </Grid>
                <Grid item>
                  <Box textAlign="right">
                    <Typography variant="h6" gutterBottom>
                      {getSelectedPhotoCount()} of {workorderDetailDialog.photos.length} selected
                    </Typography>
                    <Button
                      size="small"
                      onClick={handleSelectAllPhotos}
                      style={{ marginRight: 8 }}
                    >
                      {getSelectedPhotoCount() === workorderDetailDialog.photos.length ? 'Deselect All' : 'Select All'}
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Box>
            
            {/* Main Preview Area */}
            <Box className={classes.previewSection}>
              {workorderDetailDialog.photos.length > 0 && (
                <>
                  <img
                    src={workorderDetailDialog.photos[currentPreviewIndex].url}
                    alt={`Photo ${currentPreviewIndex + 1}`}
                    className={classes.previewImage}
                    onClick={() => setPhotoPreviewDialog({ 
                      open: true, 
                      photo: workorderDetailDialog.photos[currentPreviewIndex].url 
                    })}
                    style={{ cursor: 'pointer' }}
                  />
                  
                  {/* Navigation Buttons */}
                  {currentPreviewIndex > 0 && (
                    <IconButton
                      className={classes.navigationButton}
                      style={{ left: 16 }}
                      onClick={() => setCurrentPreviewIndex(prev => prev - 1)}
                    >
                      <NavigateBeforeIcon fontSize="large" />
                    </IconButton>
                  )}
                  
                  {currentPreviewIndex < workorderDetailDialog.photos.length - 1 && (
                    <IconButton
                      className={classes.navigationButton}
                      style={{ right: 16 }}
                      onClick={() => setCurrentPreviewIndex(prev => prev + 1)}
                    >
                      <NavigateNextIcon fontSize="large" />
                    </IconButton>
                  )}
                  
                  {/* Photo Info Overlay */}
                  <Box position="absolute" bottom={16} left={16} right={16}>
                    <Paper style={{ padding: '8px 16px', backgroundColor: 'rgba(255,255,255,0.9)' }}>
                      <Typography variant="body2">
                        Photo {currentPreviewIndex + 1} of {workorderDetailDialog.photos.length}
                        {workorderDetailDialog.photos[currentPreviewIndex].created_by && (
                          <> • By: {workorderDetailDialog.photos[currentPreviewIndex].created_by}</>
                        )}
                        {workorderDetailDialog.photos[currentPreviewIndex].created_at && (
                          <> • {moment(workorderDetailDialog.photos[currentPreviewIndex].created_at).format('MM/DD/YY h:mm A')}</>
                        )}
                      </Typography>
                    </Paper>
                  </Box>
                </>
              )}
            </Box>
            
            {/* Thumbnail Strip */}
            <Box className={classes.thumbnailSection}>
              {workorderDetailDialog.photos.map((photo, index) => {
                const photoId = photo._id || photo.url;
                const photoKey = `${workorderDetailDialog.customerId}_${workorderDetailDialog.workorder._id}`;
                const isSelected = selectedPhotos[photoKey]?.[photoId] || false;
                
                return (
                  <Box
                    key={index}
                    className={`${classes.thumbnailItem} ${
                      currentPreviewIndex === index ? classes.thumbnailSelected : ''
                    }`}
                    onClick={() => setCurrentPreviewIndex(index)}
                  >
                    <img
                      src={photo.url}
                      alt={`Thumbnail ${index + 1}`}
                      className={classes.thumbnailImage}
                    />
                    <Checkbox
                      className={classes.photoSelectionCheckbox}
                      checked={isSelected}
                      onChange={(e) => {
                        e.stopPropagation();
                        handlePhotoSelect(photoId);
                      }}
                      onClick={(e) => e.stopPropagation()}
                      size="small"
                      color="primary"
                    />
                  </Box>
                );
              })}
            </Box>
            
            <Box className={classes.workorderDetailActions}>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs>
                  <Typography variant="body2" color="textSecondary">
                    Select photos to include in the notification email
                  </Typography>
                </Grid>
                <Grid item>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      setWorkorderDetailDialog({ 
                        open: false, 
                        workorder: null, 
                        customerId: null, 
                        photos: [] 
                      });
                      setCurrentPreviewIndex(0);
                    }}
                  >
                    Close
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<SendIcon />}
                    style={{ marginLeft: 8 }}
                    onClick={handleSendFromModal}
                    disabled={getSelectedPhotoCount() === 0}
                  >
                    Send {getSelectedPhotoCount()} Photo{getSelectedPhotoCount() !== 1 ? 's' : ''}
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Box>
        )}
      </Dialog>

      {/* Progress Dialog */}
      <Dialog
        open={progressDialog.open}
        onClose={() => progressDialog.completed && setProgressDialog({
          open: false,
          steps: [],
          currentStep: '',
          error: null,
          completed: false
        })}
        className={classes.progressDialog}
        disableBackdropClick={!progressDialog.completed && !progressDialog.error}
        disableEscapeKeyDown={!progressDialog.completed && !progressDialog.error}
      >
        <Box className={classes.progressContent}>
          <Box className={classes.progressHeader}>
            <Typography variant="h6">
              Sending Photo Notification
            </Typography>
            {(progressDialog.completed || progressDialog.error) && (
              <IconButton
                size="small"
                onClick={() => setProgressDialog({
                  open: false,
                  steps: [],
                  currentStep: '',
                  error: null,
                  completed: false
                })}
              >
                <CloseIcon />
              </IconButton>
            )}
          </Box>
          
          {!progressDialog.completed && !progressDialog.error && (
            <LinearProgress />
          )}
          
          <Box mt={2} mb={1}>
            <Typography variant="body1" color={progressDialog.error ? 'error' : 'textPrimary'}>
              {progressDialog.currentStep}
            </Typography>
          </Box>
          
          {progressDialog.error && (
            <Box mt={2} p={2} bgcolor="error.light" borderRadius={1}>
              <Typography variant="body2" color="error.contrastText">
                {progressDialog.error}
              </Typography>
            </Box>
          )}
          
          <Box className={classes.progressSteps}>
            {progressDialog.steps.map((step, index) => (
              <Box
                key={index}
                className={`${classes.progressStep} ${
                  step.status === 'active' ? 'active' : 
                  step.status === 'completed' ? 'completed' : 
                  step.status === 'error' ? 'error' : ''
                }`}
              >
                {step.status === 'completed' ? (
                  <DoneIcon className={classes.progressIcon} />
                ) : step.status === 'error' ? (
                  <ErrorOutlineIcon className={classes.progressIcon} />
                ) : (
                  <CircularProgress size={20} className={classes.progressIcon} />
                )}
                <Box flex={1}>
                  <Typography variant="body2">{step.message}</Typography>
                  <Typography variant="caption" color="textSecondary">
                    {moment(step.timestamp).format('h:mm:ss A')}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>
          
          {progressDialog.completed && (
            <Box mt={3} textAlign="center">
              <CheckCircleIcon style={{ fontSize: 48, color: '#4caf50' }} />
              <Typography variant="h6" style={{ marginTop: 8 }}>
                Success!
              </Typography>
            </Box>
          )}
        </Box>
      </Dialog>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert 
          onClose={() => setSnackbar({ ...snackbar, open: false })} 
          severity={snackbar.severity}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Container>
  );
};

const mapStateToProps = state => ({
  user: state.user
});

export default connect(mapStateToProps)(PhotoNotificationDashboard);